import { RoutePage } from "@/components/RoutePage";
import { TechnologySection } from "@/components/sections/TechnologySection";

export default function TechnologyPage({ onOpenContact }) {
  return (
    <RoutePage
      kicker="The Technology"
      badge="T"
      accent="#2563EB"
      title="Soft where it matters. Sharp where it counts."
      intro="Silk-inspired flexibility for the tissue interface. Physics-aware AI for the signal. The technology layer is designed so compatibility and precision aren't a trade-off — they're the same design choice."
      primaryCta="Discuss collaboration"
      secondaryCta={{ href: "/ai", label: "See the AI stack" }}
      onOpenContact={onOpenContact}
      prev={{ href: "/platform", label: "Platform" }}
      next={{ href: "/ai", label: "AI" }}
      meta={{
        title: "Technology",
        description:
          "Neurobolt.AI's biocompatible interface concepts and physics-aware AI — designed for long-term signal compatibility and interpretable modeling.",
        path: "/technology",
      }}
      stats={[
        { k: "5", v: "Platform pillars" },
        { k: "Soft", v: "Silk-inspired" },
        { k: "Long-term", v: "Compatibility" },
        { k: "Open", v: "Research-stage" },
      ]}
    >
      <TechnologySection />
    </RoutePage>
  );
}
